const LinksMovidesk = {
  CENTRA_DE_AJUDA: "https://ajuda.fortestecnologia.com.br/kb/pt-br/article/550230/novidades-da-versao-fortes-bi?menuId=54163-141153-550230&ticketId=&q=",
  CHAT_PESSOAL: "https://sites.google.com/fortestecnologia.com.br/chatpessoal-bi",
  CHAT_RH: "https://sites.google.com/fortestecnologia.com.br/chat-rh-bi?pli=1"
}

export default LinksMovidesk;